import ModulesLoading from "theme/libs/wordpress/content/ModulesLoading";
import React from "react";
import loadable from "@loadable/component";

const MODULES = {
    default: loadable(() => import("theme/libs/wordpress/content/cmsLayouts/default/TwoColumnsLayout"), {
        fallback: (
            <ModulesLoading
                ratio={[360 / 348, null, 768 / 244, 1024 / 195, 1366 / 263]}
                py={["20px", null, null, null, null, "40px"]}
            />
        ),
    }),
};

const TwoColumnsPlaceholder = ({ content, isFirstModule }) => {
    const TwoColumnsLayout = MODULES["default"];

    return <TwoColumnsLayout {...content} />;
};

export default TwoColumnsPlaceholder;
